import type { FormElement } from '../model/form.types';
import { migrateDateInputProperties } from './migrateDateInputProperties';
import { migrateNumberInputProperties } from './migrateNumberInputProperties';
import { migrateTableHeaderToHeader } from './useHeaderTableFactory';

export function migrateLoadedElements(elements: FormElement[]): FormElement[] {
  return migrateDateInputProperties(
    migrateNumberInputProperties(migrateTableHeaderToHeader(elements))
  );
}
